import { render, staticRenderFns } from "./VaDataTable.demo.vue?vue&type=template&id=020d3b64&"
import script from "./VaDataTable.demo.vue?vue&type=script&lang=js&"
export * from "./VaDataTable.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports